export const OverviewApiUrls = {
  data: '/employees/overview',
  dataXls: '/employees/overview-xls',
  dataOtherEvents: '/employees/overviewOtherEvents',
};
